var _excluded = ["desc", "focusable", "title", "iconName", "className"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from 'react';
import { string, bool } from 'prop-types';
import classNames from 'classnames';
var svg = /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 32 32"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16 3A13 13 0 113 16 13 13 0 0116 3m0-1a14 14 0 1014 14A14 14 0 0016 2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.16 15.486l.13-.164a7.495 7.495 0 000-9.172l-.13-.165-.13.165a7.492 7.492 0 000 9.172zm1.198-.282l-.18.282.326-.075a5.725 5.725 0 004.402-4.996l.017-.167-.167.017A5.655 5.655 0 0018.53 11.7h-.001a7.207 7.207 0 01-1.166 3.493zm8.468.108a1.126 1.126 0 00-1.674-.231l-2.717 2.09a1.687 1.687 0 01.154.698 1.705 1.705 0 01-1.703 1.703h-3.414a.34.34 0 010-.679h3.413a1.025 1.025 0 10.007-2.049h-8.28a1.935 1.935 0 00-1.323.563S8.083 19.74 7.183 20.7a.677.677 0 00.018.943l1.791 1.792a.676.676 0 00.935.02l1.093-1.023a.667.667 0 01.496-.16h7.046a3.167 3.167 0 001.295-.296 16.19 16.19 0 005.939-5.395 1.163 1.163 0 00.03-1.27z"
}));

var Icon = function Icon(_ref) {
  var desc = _ref.desc,
      _ref$focusable = _ref.focusable,
      focusable = _ref$focusable === void 0 ? false : _ref$focusable,
      title = _ref.title,
      iconName = _ref.iconName,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    focusable: String(focusable),
    className: classNames('rds-svg--sustainability-circle-icon', className)
  }, rest, svg.props), title && /*#__PURE__*/React.createElement("title", null, title), desc && /*#__PURE__*/React.createElement("desc", null, desc), svg.props.children);
};

Icon.propTypes = {
  desc: string,
  focusable: bool,
  title: string,
  iconName: string,
  className: string
};
Icon.displayName = 'SustainabilityCircleIcon';
export default Icon;